export default "__VITE_ASSET__c1463ae0__"